import React, { useState } from 'react';

import { StyledRadio } from 'components/UI/StyledRadio';

type Props<T> = {
  name: string;
  label: string;
  options: T;
  selected: string;
  multiple?: boolean;
  className?: string;
  onChange: (itemId: keyof T) => void;
};

export const RadioGroup = <T extends Record<string, string>>(props: Props<T>) => {
  const [showTapAnimation, setShowTapAnimation] = useState<string>('');

  const handleChange = (optionId: string) => {
    setShowTapAnimation(optionId);
    props.onChange(optionId);
  };

  return (
    <aside className={`radio-group ${props.className || ''}`}>
      <h1 className='radio-group__label lh-1 mb-1'>{props.label}</h1>

      {Object.entries(props.options).map(([optionId, optionLabel]) => {
        return (
          <StyledRadio
            key={optionId}
            className='radio-group__option'
            name={props.name}
            label={optionLabel}
            value={optionId}
            checked={optionId === props.selected}
            onChange={() => handleChange(optionId)}
            showTapAnimation={showTapAnimation === optionId}
          />
        );
      })}
    </aside>
  );
};
